// createGrupoAtivosHook.js
import { useState, useEffect, useMemo } from "react"
import CalcService from "src/services/calc-service"

export const createGrupoAtivosHook = (tiposEmissao) => {
    return (reloadKey = 0) => {
        const [options, setOptions] = useState([])
        const calcService = useMemo(() => new CalcService(), [])

        useEffect(() => {
            let mounted = true
            calcService.recuperaGrupoAtivos(tiposEmissao)
                .then(result => {
                    if (mounted) setOptions(result.map(item =>
                        typeof item === "string" ? item : item.value ?? String(item)
                    ))
                })
                .catch(err => console.error("Erro ao carregar GrupoAtivos:", err))
            return () => { mounted = false }
        }, [calcService, reloadKey])

        return options
    }
}